import React, { useEffect, useState } from 'react'
import useAxiosInstance from '../../hooks/useAxios';
import FormRender from '../../components/FormRender';
import Select from "react-select";
import { useSelector } from 'react-redux';
import { MdInfoOutline } from 'react-icons/md';
import { ModalComp } from '../../components/Modal';
import { Paginator } from '../../components/Paginator';
import { toast } from 'react-toastify';

const QnAData = () => {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState({});
  const { allComponentsIds } = useSelector((state) => state.globalAuth);

  const axiosInstance = useAxiosInstance();
  const [questionData, setQuestionData] = useState([])
  const [questionModal, setQuestionModal] = useState(false)
  const [formData, setFormData] = useState(
    {
      "user_ids": {},
      "report_ids": "",
      "start_date": "",
      "end_date": "",
      "component_ids": [],
      "page": 1,
      "page_size": 5,
      "version":"new"
    }
  );
  const handleDataUpdate = (page=null) => {
    setLoading(true);
    axiosInstance
      .post(formData.version == 'new'? "/accounts/qna_data/" : "/accounts/qna_old_data/", {...formData, page:page?page:formData.page})
      .then((res) => {
        setResponse(res.data.data)
        setLoading(false);
      })
      .catch((err) => {
        toast.error('Something went wrong!')
        setLoading(false);
      });
  }

  function count(col,row){
    return col === 'username' ?
        row?.[col]
        :
        row?.[col]?.questions?.ques_count ? row?.[col]?.questions?.ques_count : 0
    }
  

  useEffect(() => {
    handleDataUpdate()
  }, [])

  return (
    <div className="h-screen overflow-y-auto mr-2">
      <p className="text-base font-semibold  my-2 px-2 py-2 bg-white rounded-lg border">
        QnA data
      </p>
      <ModalComp
        width={400}
        open={questionModal}
        onClose={() => {
          setQuestionModal(false);
        }}
      >
        <div className="p-4 rounded-xl bg-white max-h-[300px] overflow-y-auto">
          <div className='p-3 rounded-xl'>
            <table className="w-full overflow-y-auto max-h-96 rounded-xl bg-slate-50 ">
              <thead className="">
                <th
                  className={`px-2 bg-white py-1 text-center`}
                >
                  <p className="flex items-center justify-left  text-xm font-medium mx-2 my-1 gap-x-1 text-center">
                    Report ID
                  </p>
                </th>

                <th
                  className={`px-2 bg-white py-1 text-center`}
                >
                  <p className="flex items-center justify-left  text-xm font-medium mx-2 my-1 gap-x-1 text-center">
                    Questions
                  </p>
                </th>
              </thead>

              <tbody className="">
                {questionData?.map((row) => {
                  return <tr className='even:bg-slate-50 odd:bg-slate-100' key={row.username}>
                    <td className='align-top  px-2 py-1 text-center'>
                      <p className='flex items-center mx-2 my-1'>
                        {row.report_id}
                      </p>
                    </td>
                    <td className='align-top max-w-xl px-2 py-1 text-center'>
                      {row.questions.map(it => { return <li key={it}>{it}</li> })}
                    </td>
                  </tr>
                })}
              </tbody>
            </table>
          </div>    </div>
      </ModalComp>
      <div>
        <FormRender
          formData={formData}
          formSettings={[{
            label: "Select User (Multi-select)",
            type: "user",
            saveKey: "user_ids"
          }]}
          setFormData={setFormData}
        />

        <div className='grid grid-cols-3 gap-3 pb-3 px-3 mt-5 bg-white rounded-xl'>
          <FormRender
            formData={formData}
            formSettings={[
              {
                label: "Report IDs (Comma Sep)",
                type: "text",
                saveKey: "report_ids"
              },
              {
                label: "Start date",
                type: "date",
                saveKey: "start_date"
              },
              {
                label: "End date",
                type: "date",
                saveKey: "end_date"
              },
              {
                label: "Page",
                type: "number",
                saveKey: "page"
              },
              {
                label: "Page Size",
                type: "number",
                saveKey: "page_size"
              },
              {
                label: "version",
                type: "select",
                saveKey: "version",
                options:[{label:"old",value:"old"},{label:"new",value:"new"}]
              },
            ]}
            setFormData={setFormData}
          />

          <div>
            <p className="text-sm font-semibold mt-4 mb-2">QnA Components (Multi-select)</p>
            <Select
              className="w-full"
              options={allComponentsIds.map(it => ({ 'label': it.name, 'value': it.pk }))}
              isMulti
              value={
                allComponentsIds.filter(it => formData?.component_ids?.includes(it.pk)).map(it => ({ 'label': it.name, 'value': it.pk }))
              }
              onChange={(e) => {
                setFormData(prev => ({ ...prev, 'component_ids': e.map(it => it.value) }))
              }}
            />
          </div>
        </div>

        <div className='flex justify-end'>
          <button
            className='mt-4 px-3 py-2 bg-black rounded-xl text-sm font-semibold text-white'
            onClick={() => {
              handleDataUpdate()
            }}
          >Apply filters</button>
        </div>

        {loading ? <span>Loading...</span> :
          <div className={`overflow-x-auto mb-5 bg-white mt-4 j-[90vh] max-h-[90vh] rounded-xl`}>
            <table className="w-full  bg-slate-50 ">
              <thead className="">
                {response?.columns?.map((col) => (
                  <th
                    key={col}
                    className={`px-2 bg-white py-1 text-center`}
                  >
                    <p className="flex items-center justify-left  text-xm font-medium mx-2 my-1 gap-x-1 text-center">
                      {col}
                    </p>
                  </th>
                ))}
              </thead>

              <tbody className="">
                {response?.questions?.map((row) => <tr className='even:bg-slate-50 odd:bg-slate-100' key={row.username}>
                  {response?.columns.map(col => {
                    return <td
                      className='align-top px-2 py-1 text-center '
                      key={col}
                    >
                      <p className={`flex items-center mx-2 my-1 ${(count(col, row)== 0 || col=='username' ) ? '':'bg-black px-1 text-white rounded-lg'}`}>
                        {
                          count(col, row)
                        }
                        <button
                          className='ml-1'
                          onClick={() => {
                            setQuestionModal(true)
                            setQuestionData(row?.[col]?.questions?.ques_with_report_ids || [])
                          }}
                        ><MdInfoOutline /></button>
                      </p>
                    </td>
                  })}
                </tr>)
                }
              </tbody>

            </table>

          </div>}

          <div className='flex gap-x-3 mb-8'>      
          <button
            className='mt-4 px-3 py-2 bg-black rounded-xl text-sm font-semibold text-white'
            onClick={() => {
              setFormData((prev=>{
                return {...prev, page:prev.page-1}
              }))
              handleDataUpdate(formData.page-1)
            }}
          >Prev</button>
          <button
            className='mt-4 px-3 py-2 bg-black rounded-xl text-sm font-semibold text-white'
            onClick={() => {
              setFormData((prev=>{
                return {...prev, page:prev.page+1}
              }))
              handleDataUpdate(formData.page+1)
            }}
          >Next</button>
        </div>
      </div>
    </div>
  )
}

export default QnAData